import { Link } from '@routable/gross-ds';
import React from 'react';
const HelpDocsLinkButton = ({ children, href }) => (React.createElement(Link, { button: {
        'data-testid': 'link:button:about-bank-transfer-limits',
        intent: 'primary',
        variant: 'outline',
        size: 'small',
    }, href: href, openInNewTab: true }, children));
export default HelpDocsLinkButton;
